import { useEffect, useState } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { InputField, Submitbtn } from "../../../Component";
import AddMoreBtn from "../../../Component/addMoreBtn";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { addBlog, getAuthorList, uploadBlogImage } from "../adminSlice";
import ImgPickerAndViewer from "../../../Component/imgPickerAndViewer";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
import {
  validateAgeGrp,
  validateIsFileImageType,
} from "../../../Utils/validators";
import { validateIsFileImageTypeErrMsg } from "../../../Utils/errorMsg";
import DateTimePicker from "../../../Component/dateTimePicker";
import moment from "moment";
import TextEditor from "../../../Component/textEditor";
import DropDown from "../../../Component/dropdown";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";


const CreateBlog = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [title, setTitle] = useState<any>("");
  const [author, setAuthor] = useState<any>("");
  const [authorUrl, setAuthorUrl] = useState<any>("");
  const [slug, setSlug] = useState<any>("");
  const [dateTime, setDateTime] = useState<any>(moment.utc(new Date()).utcOffset(330).format("YYYY-MM-DD HH:mm:ss"));
  const [metaTitle, setMetaTitle] = useState<any>("");
  const [metaDesc, setMetaDesc] = useState<any>("");
  const [readingTime, setReadingTime] = useState<any>("");
  const [heroImage, setHeroImage] = useState<any>("");
  const [uploadHeroImage, setUploadHeroImage] = useState<any>("");
  const [authorList, setAuthorList] = useState<any>([]);
  const initialVal = [
    {
      subTitle: "",
      contentDescription: "",
      image: "",
      imagePreview: ""
    },
  ];
  const [otherDetailsArr, setOtherDetailsArr] = useState<any>(initialVal);

  useEffect(() => {

    dispatch(
      getAuthorList({
        callback: (res: any) => {
          setAuthorList(res?.data);
        },
        errorCallback: () => { },
      })
    );
  }, []);
  const onchangeTitle = (value: any) => {
    setTitle(value);
  };
  const onchangeAuthor = (value: any) => {
    setAuthor(value);
  };
  const onchangeAuthorUrl = (value: any) => {
    setAuthorUrl(value);
  };
  const onchangeSlug = (value: any) => {
    setSlug(value);
  };
  const onchangeDateTime = (value: any) => {
    setDateTime(value);
  };
  const onchangeMetaTitle = (value: any) => {
    setMetaTitle(value);
  };
  const onchangeMetaDesc = (value: any) => {
    setMetaDesc(value);
  };
  const onchangeReadingTime = (value: any) => {
    if (validateAgeGrp(value)) {
      setReadingTime(value);
    }
  };
  const onchangeHeroImage = (value: any) => {
    if (!validateIsFileImageType(value)) {
      return;
    } else {
      const reader = new FileReader();
      const file = value.target.files[0];
      reader.onloadend = () => {
        setHeroImage(reader.result);
      };
      reader.readAsDataURL(file);
      dispatch(
        uploadBlogImage({
          params: file,
          callback: (res: any) => {
            if (res) {
              setUploadHeroImage(res?.data?.name);
            }
          },
          errorCallback: () => { },
        })
      );
    }
  };
  
  const onchangeOtherDetails = (value: any, index: any, key: any) => {
    const newArr = [...otherDetailsArr];
    const mediaTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];
    if (key === "image") {
      if (!validateIsFileImageType(value)) return;
      const reader = new FileReader();
      const file = value.target.files[0];
      if (!file || !mediaTypes.includes(file.type) || !validateIsFileImageType(value)) {
        return;
      }
      reader.onloadend = () => {
        setOtherDetailsArr((prev: any) => {
          const updated = [...prev];
          updated[index] = {
            ...updated[index],
            imagePreview: reader.result,
          };
          return updated;
        });
      };
      reader.readAsDataURL(file);
      dispatch(
        uploadBlogImage({
          params: file,
          callback: (res: any) => {
            if (res?.status === "success") {
              setOtherDetailsArr((prev: any) => {
                const updated = [...prev];
                updated[index] = {
                  ...updated[index],
                  [key]: res.data.name,
                };
                return updated;
              })
            }
          },
          errorCallback: () => { },
        })
      );
    } else {
      setOtherDetailsArr((prev: any) => {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          [key]: value,
        };
        return updated;
      });
    }
  };
  const handleClose = (index: any) => {
    const newArrr = [...otherDetailsArr];
    if (index > -1) {
      newArrr.splice(index, 1);
    }
    setOtherDetailsArr(newArrr);
  };
  const onPressAdd = () => {
    setOtherDetailsArr([...otherDetailsArr, initialVal[0]]);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const updatedProduct = otherDetailsArr.map((item: any) => { const { imagePreview, ...rest } = item; return rest });
    const postData = {
      title: title,
      authorId: author?._id,
      slug: slug,
      dateTime: dateTime,
      metaTitle: metaTitle,
      metaDescription: metaDesc,
      timeOfreading: readingTime,
      heroImage: uploadHeroImage,
      details: updatedProduct,
    };
    dispatch(
      addBlog({
        params: postData,
        callback: (res: any) => {
          if (res?.status === "success") {
            setTitle("");
            setAuthor("");
            setAuthorUrl("");
            setSlug("");
            setDateTime(moment.utc(new Date()).utcOffset(330).format("YYYY-MM-DD HH:mm:ss"));
            setMetaTitle("");
            setMetaDesc("");
            setReadingTime("");
            setHeroImage("");
            setUploadHeroImage("");
            setOtherDetailsArr([]);
            dispatch(showSnackbar({ message: res?.msg, type: res?.type }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };

  const validations = () => {
    let valid = false;
    otherDetailsArr.map((item: any) => {
      if (
        item?.subtitle === "" ||
        item?.image === "" ||
        item?.description === ""
      ) {
        valid = true;
      }
    });
    if (title === "") {
      valid = true;
    }
    if (author === "") {
      valid = true;
    }
    // if (authorUrl === "") {
    //   valid = true;
    // }
    if (slug === "") {
      valid = true;
    }
    if (dateTime === "") {
      valid = true;
    }
    if (metaTitle === "") {
      valid = true;
    }
    if (metaDesc === "") {
      valid = true;
    }
    if (readingTime === "") {
      valid = true;
    }
    if (heroImage === "") {
      valid = true;
    }
    return valid;
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"Create Blog "} />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius mb-4 ">
          <form onSubmit={handleSubmit}>
            <div className="row align-items-center ">
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Title"} isRequired />
                <InputField
                  placeholder={"Enter Title"}
                  setInputText={(value: any) => onchangeTitle(value)}
                  value={title}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Author"} isRequired />
                <DropDown
                  labelName={"Select Author"}
                  setInputText={(value: any) => onchangeAuthor(value)}
                  options={authorList}
                  value={author}
                />
              </div>
              {/* <div className="col-md-4 mb-3">
                <LabelInput labelName={"Author URL"} isRequired />
                <InputField
                  placeholder={"Enter Author URL"}
                  setInputText={(value: any) => onchangeAuthorUrl(value)}
                  value={authorUrl}
                />

              </div> */}
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Slug"} isRequired />
                <InputField
                  placeholder={"Enter Slug"}
                  setInputText={(value: any) => onchangeSlug(value)}
                  value={slug}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Date & Time"} isRequired />
                <DateTimePicker
                  setInputText={(value: any) => {
                    onchangeDateTime(value);
                  }}
                  value={dateTime}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Meta Title"} isRequired />
                <InputField
                  placeholder={"Enter Meta Title"}
                  setInputText={(value: any) => onchangeMetaTitle(value)}
                  value={metaTitle}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Meta Description"} isRequired />
                <InputField
                  placeholder={"Enter Meta Description"}
                  setInputText={(value: any) => onchangeMetaDesc(value)}
                  value={metaDesc}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Reading Time (in minute)"} isRequired />
                <InputField
                  placeholder={"Enter Reading Time in Minute"}
                  setInputText={(value: any) => onchangeReadingTime(value)}
                  value={readingTime}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Hero Image"} isRequired />
                <ImgPickerAndViewer
                  handleChange={(value: any) => onchangeHeroImage(value)}
                  value={heroImage}
                />
              </div>
              <div className="col-md-12">
                <div className=" ">
                  {otherDetailsArr.map((item: any, index: any) => {
                    return (
                      <div className=" d-flex mt-2 ">
                        <div className="col-md-11 pe-2 row d-flex border rounded p-4">
                          <div className="d-flex ">
                            <div className="me-3  ">
                              <LabelInput
                                labelName={"Sub Title "}
                                isRequired
                              />
                              <InputField
                                key={"ex2"}
                                placeholder={"Enter Sub Title "}
                                setInputText={(value: any) =>
                                  onchangeOtherDetails(
                                    value,
                                    index,
                                    "subTitle"
                                  )
                                }
                                value={item?.SubTitle}
                              />
                            </div>
                            <div className="me-3">
                              <LabelInput labelName={"Image"} isRequired />
                              <div className="">
                                <ImagePickerAndViewer
                                  value={item?.imagePreview}
                                  handleChange={(value: any) => (onchangeOtherDetails(value, index, "image"))}
                                  htmlFor={`photo-upload-${index}`}
                                  doctype={""} />
                              </div>
                            </div>
                          </div>
                          <div className="me-3  ">
                            <LabelInput
                              labelName={"Description "}
                              isRequired
                            />
                            <TextEditor
                              onChange={(value: any) =>
                                onchangeOtherDetails(
                                  value,
                                  index,
                                  "contentDescription"
                                )
                              }
                              value={item?.Description}
                            />
                          </div>
                        </div>
                        {otherDetailsArr.length === 1 ? null : (
                          <DeleteForeverIcon
                            className="cursor ms-3"
                            color="error"
                            fontSize="small"
                            onClick={() => handleClose(index)}
                          />
                        )}
                      </div>
                    );
                  })}
                  <div className="d-flex justify-content-end mt-4 ">
                    <div className="col-3">
                      <AddMoreBtn handleClick={onPressAdd} />
                    </div>
                  </div>
                  <div className="d-flex justify-content-center mt-3">
                    <div className="col-2 pt-2">
                      <Submitbtn name={"Submit"} disabled={validations()} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateBlog;
